module.exports = __webpack_public_path__ + "static/media/YF81_6.a518f407.jpg";